module.exports = __webpack_public_path__ + "static/media/Panorama-Piha-beach.0f7ecef9.jpg";